module.exports = __webpack_public_path__ + "static/media/submitContact.1c44ca71.png";